"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsWeb = require("@telus-uds/components-web");
var _RichTextPropTypes = require("./RichTextPropTypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var RichTextParagraph = _ref => {
  var {
    colour = 'default',
    inverse = false,
    size = 'medium',
    align = 'auto',
    children,
    testID
  } = _ref;
  var variant = {
    inverse
  };
  if (!inverse) {
    variant.colour = colour;
  }
  if (size !== 'medium') {
    variant.size = size;
  }
  return /*#__PURE__*/_react.default.createElement(_componentsWeb.Typography, {
    block: true,
    variant: variant,
    "data-testid": testID,
    align: align
  }, children);
};
RichTextParagraph.propTypes = {
  linesBetween: _propTypes.default.number,
  colour: _propTypes.default.oneOf(_RichTextPropTypes.variantColors),
  inverse: _propTypes.default.bool,
  size: _propTypes.default.oneOf(_RichTextPropTypes.variantSizes),
  align: _propTypes.default.oneOf(_RichTextPropTypes.alignOptions),
  children: _propTypes.default.node,
  testID: _propTypes.default.string
};
var _default = exports.default = RichTextParagraph;